import { createContext, useState, useMemo } from 'react'
import { node } from 'prop-types'
import { api } from 'api'

export const accountContext = createContext({})

export const AccountProvider = ({ children }) => {
  const [byId, setById] = useState({})

  const fetchAccounts = useMemo(
    () => () =>
      api.get('/api/v1/account/connector').then(({ data }) => {
        const initialValue = {}
        setById(() =>
          data.reduce(
            (acc, row) => ({
              ...acc,
              [row.id]: { ...row, type: row.connector_type ? row.connector_type.name : '' },
            }),
            initialValue,
          ),
        )
        return data
      }),
    [],
  )

  const updateConnectedAccounts = newConnectedAccounts => {
    setById(newConnectedAccounts)
  }

  const updateById = newItem => {
    setById({
      ...byId,
      [newItem.id]: { ...newItem, type: newItem.connector_type ? newItem.connector_type.name : '' },
    })
  }

  const value = useMemo(
    () => ({
      byId,
      fetchAccounts,
      updateConnectedAccounts,
      updateById,
    }),
    [byId, fetchAccounts, updateConnectedAccounts],
  )

  return <accountContext.Provider value={value}>{children}</accountContext.Provider>
}

AccountProvider.propTypes = {
  children: node.isRequired,
}
